// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const Pulse = function(elm: any) {
   const el = angular.element(elm)
   return el.filter(':not(:animated)').stop().animate({
      padding: '8px 4px',
      fontSize: '190%'
   }
   , 250).promise().always(() => el.animate({
      fontSize: '95%',
      padding: '4px'
   }
   , 250))
}

const Shake = function(elm: any, shakes = 4, distance = 4, duration = 500) {
   let x = 1
   return (() => {
      const result = []
      while (x <= shakes) {
         angular.element(elm).animate(
            {left: distance * -1}
            , ((duration / shakes) / 5)).animate(
            {left: distance}
            , ((duration / shakes) / 3)).animate(
            {left: distance * -distance}
            , ((duration / shakes) / 5))
         result.push(x++)
      }
      return result
   })()
}

const EventAnimate = () => ({
   link(scope: any, element: any, attrs: any) {
      const eventAnimateAttr = scope.$eval(attrs.eventAnimate)
      return (() => {
         const result = []
         for (var ev in eventAnimateAttr) {
            var evElms = eventAnimateAttr[ev]
            result.push((() => {
               const result1 = []
               for (var elm in evElms) {
                  var evClass = evElms[elm]
                  result1.push(element.on(ev, (((elm, evClass) => (function() {
                     if (elm === 'this') { elm = element }
                     return angular.element(elm).addClass(evClass)
                        .one("webkitAnimationEnd oanimationend msAnimationEnd animationend webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend"
                           , () => angular.element(elm).removeClass(evClass))
                  })))(elm, evClass)
                  ))
               }
               return result1
            })())
         }
         return result
      })()
   }
})

angular.module('summonApp.directives')
   .directive('eventAnimate', EventAnimate)
